import {
  ATTENDANCE_URL,
  BASE_URL,
  BONUS_REPORT_URL,
  EMPLOYEE_URL,
  FORM_URL,
  GRATUITY_URL,
  SALARY_SUMMARY_URL,
} from "../constants";
import { apiSlice } from "./apiSlice";

export const adminApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMenuList: builder.mutation({
      query: (formData) => ({
        url: BASE_URL,
        method: "POST",
        body: formData,
      }),
    }),

    getSalarySlipForEmployee: builder.mutation({
      query: (formData) => ({
        url: BASE_URL,
        method: "POST",
        body: formData,
      }),
    }),
    getForm14ForEmployee: builder.mutation({
      query: (formData) => ({
        url: BASE_URL,
        method: "POST",
        body: formData,
      }),
    }),
    getGratuityReport: builder.mutation({
      query: (formData) => ({
        url: GRATUITY_URL,
        method: "POST",
        body: formData,
      }),
    }),
    getSalarySheetSummary: builder.mutation({
      query: (formData) => ({
        url: SALARY_SUMMARY_URL,
        method: "POST",
        body: formData,
      }),
    }),
    getYearlyBonusReports: builder.mutation({
      query: (formData) => ({
        url: BONUS_REPORT_URL,
        method: "POST",
        body: formData,
      }),
    }),
    getForm21: builder.mutation({
      query: (formData) => ({
        url: FORM_URL,
        method: "POST",
        body: formData,
      }),
    }),
    getForm22: builder.mutation({
      query: (formData) => ({
        url: FORM_URL,
        method: "POST",
        body: formData,
      }),
    }),
    getForm24: builder.mutation({
      query: (formData) => ({
        url: FORM_URL,
        method: "POST",
        body: formData,
      }),
    }),
    getForm25: builder.mutation({
      query: (formData) => ({
        url: FORM_URL,
        method: "POST",
        body: formData,
      }),
    }),
    getLeaveRejoinReports: builder.mutation({
      query: (formData) => ({
        url: EMPLOYEE_URL,
        method: "POST",
        body: formData,
      }),
    }),
    getAttendance: builder.mutation({
      query: (formData) => ({
        url: ATTENDANCE_URL,
        method: "POST",
        body: formData,
      }),
    }),

     getYearlyPFESIReports: builder.mutation({
      query: (formData) => ({
        url: BONUS_REPORT_URL,
        method: "POST",
        body: formData,
      }),
    }),

  }),
});

export const {
  useGetSalarySlipForEmployeeMutation,
  useGetForm14ForEmployeeMutation,
  useGetGratuityReportMutation,
  useGetSalarySheetSummaryMutation,
  useGetYearlyBonusReportsMutation,
  useGetForm21Mutation,
  useGetForm22Mutation,
  useGetForm24Mutation,
  useGetForm25Mutation,
  useGetLeaveRejoinReportsMutation,
  useGetAttendanceMutation,
  useGetMenuListMutation,
  getYearlyPFESIReportsMutation
} = adminApiSlice;
